import request from "@/router/axios";
export const ruleList = () => {
  return request({
    url: `/api/jy/rule/group/ruleList`,
    method: "get",
  });
};

export const getRules = (ruleId) => {
  return request({
    url: `/api/jy/rule/group/getRules`,
    method: "get",
    params: {
      ruleId,
    },
    timeout: 120000,
  });
};
export const saveRules = (data) => {
  return request({
    url: `/api/jy/rule/group/saveRules`,
    method: "post",
    data,
    timeout: 120000,
  });
};
export const removeRule = (ruleId) => {
  return request({
    url: `/api/jy/rule/group/removeRule`,
    method: "post",
    params: {
      ruleId,
    },
  });
};
